<template>
    <div class="pdf_loader">
        <div class="pdf" style="height: 90vh" v-if="iframeSignedUrl">
            <iframe  style="border: 0px" :src="iframeSignedUrl" height="100%"  width="100%"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
            routeToken:null,
            token:'',
            apiToken:'',
            tokenUserId:'',
            iframeSignedUrl:''
        }
    },
    methods: {
        getIframeUrl(){
            let path = 'https://viewer.estrokes.com';
            if (this.token) {
                path += '?dev=false';
                path += '&token=' + this.token;
            }
            if (this.apiToken) {
                path += '&apiToken=' + this.apiToken;
            }
            this.iframeSignedUrl =  path + '&date=' + new Date().getTime();
        }
    },
    mounted() {
        if(this.$route && this.$route.query){
            this.routeToken = this.$route.query;
            if(this.routeToken && this.routeToken['token']){
                this.token = this.routeToken['token']
            }
            if(this.routeToken && this.routeToken['apiToken']){
                this.apiToken = this.routeToken['apiToken']
            }
            if(this.routeToken && this.routeToken['userId']){
                this.tokenUserId = this.routeToken['userId']
            }
            this.getIframeUrl();
        }
        
    }
}
</script>